import { notification as antdNotification } from 'antd';

const notification = (type: 'success' | 'error', message: string, description: string) => {
	antdNotification[type]({
		message: message,
		description: description,
	});
};

export default notification;
